import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const QUOTES = [
  {
    text: "Our daughter went from two-word phrases to narrating her whole day at dinner. Every session felt like play — she asks when the therapist is visiting next.",
    name: "Priya R.",
    role: "Parent, partner school",
  },
  {
    text: "My son's stammering made him dread speaking up in class. After a term of in-school sessions, he volunteered for the school play. We cried.",
    name: "Meena S.",
    role: "Parent, partner school",
  },
  {
    text: "Screenings happened quietly between classes, and the monthly reports made parent meetings easy. The most seamless specialist programme we've run.",
    name: "Dana K.",
    role: "School Principal",
  },
];

export const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(1);
  const go = (d) => {
    setDir(d);
    setIndex((i) => (i + d + QUOTES.length) % QUOTES.length);
  };
  const q = QUOTES[index];

  return (
    <section id="stories" className="border-y border-pine-900/10 bg-sand py-24 lg:py-32">
      <div className="mx-auto max-w-5xl px-5 text-center sm:px-8">
        <Reveal>
          <Quote size={28} className="mx-auto mb-8 text-clay" fill="currentColor" strokeWidth={0} />
        </Reveal>
        <div className="relative min-h-[220px] sm:min-h-[190px]" data-testid="testimonial-carousel">
          <AnimatePresence mode="wait" custom={dir}>
            <motion.blockquote
              key={index}
              initial={{ opacity: 0, x: dir * 40 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: dir * -40 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            >
              <p className="font-serif text-xl font-medium italic leading-relaxed text-pine-950 sm:text-2xl lg:text-3xl">
                “{q.text}”
              </p>
              <footer className="mt-8">
                <p className="text-sm font-semibold text-pine-900" data-testid="testimonial-author">{q.name}</p>
                <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">{q.role}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-10 flex items-center justify-center gap-4">
          <button
            data-testid="testimonial-prev-button"
            onClick={() => go(-1)}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-pine-900/20 text-pine-900 transition-[background-color,border-color] duration-300 hover:border-pine-900 hover:bg-pine-900 hover:text-cream"
            aria-label="Previous testimonial"
          >
            <ArrowLeft size={16} />
          </button>
          <span className="font-mono text-xs text-stone-500">{index + 1} / {QUOTES.length}</span>
          <button
            data-testid="testimonial-next-button"
            onClick={() => go(1)}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-pine-900/20 text-pine-900 transition-[background-color,border-color] duration-300 hover:border-pine-900 hover:bg-pine-900 hover:text-cream"
            aria-label="Next testimonial"
          >
            <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};
